// Mocked "acquired models" feed for the Select or upload 3D Model picker. The list
// endpoint (ClickUp 86cbdjad7) does not exist yet, so it is stubbed here behind the
// payload shape agreed on that task - swapping it for an axios call should not touch
// anything outside this file.
import chameleon from 'images/three_d_studio/ai_sign_in_modal/chameleon.webp'
import drone from 'images/three_d_studio/ai_sign_in_modal/drone.webp'
import aircraft from 'images/three_d_studio/aircraft.jpg'
import animals from 'images/three_d_studio/animals.jpg'
import car from 'images/three_d_studio/car.jpg'
import character from 'images/three_d_studio/character.jpg'
import generated1 from 'images/three_d_studio/generated-1.jpg'
import laptop from 'images/three_d_studio/mocked_model/laptop.webp'
import sword from 'images/three_d_studio/variations_tab/sword.webp'

// `viewerCompatible: false` marks a purchase with no glb/gltf/fbx/obj/stl file the
// viewer can open - the picker disables those cards.
const ACQUIRED_MODELS = [
  { id: 101, title: 'Buggy concept car', thumbnailUrl: car, viewerCompatible: true },
  { id: 102, title: 'Astronaut suit pack', thumbnailUrl: character, viewerCompatible: true },
  { id: 103, title: 'Running sports figure', thumbnailUrl: generated1, viewerCompatible: true },
  { id: 104, title: 'Dragon phoenix', thumbnailUrl: animals, viewerCompatible: true },
  { id: 105, title: 'Electric sedan', thumbnailUrl: aircraft, viewerCompatible: true },
  { id: 106, title: 'Off-road SUV', thumbnailUrl: laptop, viewerCompatible: false },
  { id: 107, title: 'Seagull in flight', thumbnailUrl: animals, viewerCompatible: true },
  { id: 108, title: 'Strawberry still life', thumbnailUrl: generated1, viewerCompatible: true },
  { id: 109, title: 'Humanoid robot', thumbnailUrl: character, viewerCompatible: true },
  { id: 110, title: 'Delivery drone', thumbnailUrl: drone, viewerCompatible: true },
  { id: 111, title: 'Forest chameleon', thumbnailUrl: chameleon, viewerCompatible: true },
  { id: 112, title: 'Ornate longsword', thumbnailUrl: sword, viewerCompatible: true },
  { id: 113, title: 'Cargo aircraft', thumbnailUrl: aircraft, viewerCompatible: false },
  { id: 114, title: 'Workstation laptop', thumbnailUrl: laptop, viewerCompatible: true },
]

const LIST_DELAY_MS = 700

/**
 * Mocked list of the models the user has acquired, paginated and searchable by title.
 * @param {{ page: number, perPage: number, keywords: string }} params
 * @returns {Promise<{ items: Array<object>, meta: object }>}
 */
export const mockFetchAcquiredModels = ({ page, perPage, keywords }) => new Promise((resolve) => {
  setTimeout(() => {
    const term = (keywords ?? '').trim().toLowerCase()
    const matches = term
      ? ACQUIRED_MODELS.filter(({ title }) => title.toLowerCase().includes(term))
      : ACQUIRED_MODELS
    const offset = (page - 1) * perPage

    resolve({
      items: matches.slice(offset, offset + perPage),
      meta: {
        currentPage: page,
        totalPages: Math.max(1, Math.ceil(matches.length / perPage)),
        totalCount: matches.length,
        perPage,
      },
    })
  }, LIST_DELAY_MS)
})
